import { useMemo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

function seriesValues(bucketSeries) {
  return (bucketSeries || []).map((point) =>
    point?.value == null ? null : Number(point.value)
  )
}

export default function PricingLevelPaceTrendChart({ paceTrend }) {
  const options = useMemo(() => {
    const categories = paceTrend?.buckets || []
    const currentValues = seriesValues(paceTrend?.current)
    const historicalValues = seriesValues(paceTrend?.historicalAverage)

    const allValues = [...currentValues, ...historicalValues].filter(
      (value) => value != null && Number.isFinite(value)
    )
    const minValue = allValues.length
      ? Math.max(0, Math.floor(Math.min(...allValues) / 10) * 10 - 10)
      : 50
    const maxValue = allValues.length
      ? Math.min(100, Math.ceil(Math.max(...allValues) / 10) * 10 + 10)
      : 100

    return {
      chart: {
        type: 'line',
        height: 320,
        backgroundColor: 'transparent',
        spacing: [12, 8, 8, 8],
      },
      title: { text: undefined },
      credits: { enabled: false },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        itemStyle: {
          fontWeight: '500',
          fontSize: '12px',
        },
      },
      xAxis: {
        categories,
        title: { text: null },
        lineColor: '#e5e7eb',
        tickColor: '#e5e7eb',
        labels: {
          style: { color: '#6b7280', fontSize: '12px' },
        },
      },
      yAxis: {
        min: minValue,
        max: maxValue,
        tickInterval: 10,
        title: { text: null },
        gridLineColor: '#eef0f2',
        labels: {
          format: '{value}%',
          style: { color: '#6b7280', fontSize: '12px' },
        },
      },
      tooltip: {
        shared: true,
        valueSuffix: '%',
        valueDecimals: 0,
      },
      plotOptions: {
        line: {
          marker: {
            enabled: true,
            radius: 4,
            symbol: 'circle',
          },
          lineWidth: 2.5,
        },
      },
      series: [
        {
          name: 'Current Event',
          data: currentValues,
          color: '#2563eb',
          connectNulls: false,
        },
        {
          name: 'Historical Average',
          data: historicalValues,
          color: '#94a3b8',
          dashStyle: 'ShortDash',
          connectNulls: false,
        },
      ],
    }
  }, [paceTrend])

  const hasData = (paceTrend?.current || []).some(
    (point) => point?.value != null
  )

  if (!hasData) {
    return (
      <p className="text-muted small mb-0">
        Pace trend requires daily pricing level snapshots leading up to the
        event.
      </p>
    )
  }

  return (
    <div className="pricing-level-pace-trend-chart">
      <HighchartsReact highcharts={Highcharts} options={options} />
      {paceTrend?.historicalSampleSize > 0 && (
        <p className="pricing-level-pace-trend-note small text-muted mb-0">
          Historical average based on {paceTrend.historicalSampleSize} completed
          event{paceTrend.historicalSampleSize === 1 ? '' : 's'}.
        </p>
      )}
    </div>
  )
}
